export const paginate = <T>(src: T[], page: number, perPage: number): T[] => {
  const lastIndex = page * perPage;
  const firstIndex = lastIndex - perPage;
  const paginated = src.slice(firstIndex, lastIndex);

  return paginated;
};
